import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import TitleModal from "./TitleModal";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";

function TitleGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [titleModel, setTitleModel] = useState({ TitleId: null, Title: "", Description: "" });
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);

  function closeModal() {
    setIsOpen(false);
    props.fetchTitles();
  }

  const rows = props.TitleData
    ? props.TitleData.filter(
      (item) =>
        (item.Title &&
          item.Title.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.Description &&
          item.Description.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    setTitleModel(row);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    const model = data;
    if (e.target.name === "Edit") {
      let titleDetails = {
        TitleId: model.TitleId,
        Title: model.Title,
        Description: model.Description,
        UserId: getStorageValues('userId')
      };
      if (validation(titleDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveTitle", 
            titleDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchTitles();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if(e.target.name === "Delete"){
      let titleDetails = {
        TitleId: titleModel.TitleId,
        UserId: getStorageValues('userId')
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/deleteTitle", titleDetails
        );
        if (response.status === 200) {
          CreateAlert("Title deleted successfully!!", "Success", setAlert);
          props.fetchTitles();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(titleDetails) {
    var validation = true;
    if (titleDetails) {
      if (titleDetails.Title !== null) {
        if (titleDetails.Title.length === 0) {
          CreateAlert("Please enter title!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please enter title!!", "Warning", setAlert);
        validation = false;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }
    return validation;
  }

  const columns = [
    {
      name:<div className="titlename"><span>Title</span></div> ,
      selector: row => row.Title,
      cell: (row) => (
        <span title={row.Title}>{row.Title}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Description </span></div>,
      selector: row => row.Description,
      cell: (row) => (
        <span title={row.Description}>{row.Description}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
  ];
  if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "View");
                }}
              >
                <Icons.Eye data-feather="eye" className="action-eye" />
              </Link>
            : null
          }
          {
            props.UserPermissions.EditModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Edit");
                }}
              >
                <Icons.Edit data-feather="edit" className="feather-edit" />
              </Link>
            : null
          }
          {
            props.UserPermissions.DeleteModule === 1 ? 
              <Link
                className="confirm-text p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Delete");
                }}
              >
                <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
              </Link>
            : null
          }
        </div>
      ),
      center: "true",
      width: "150px"
    },);
  };

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="Title"
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
      <TitleModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={titleModel}
        onSubmit={onSubmit}
      />
    </>
  );
}

export default TitleGrid;
